import getLocal from '@/app/utils/i18n';
import { useLang } from '@/i18n';
import css from './index.module.scss';
import { useState, useEffect } from 'react';

const H: React.FC = () => {
    const { t } = useLang('stream_ultra_x');
    const { locale } = getLocal();
    const [load, setLoad] = useState(false);

    // 格式化数字，德国地区大于1000时使用窄空格分隔
    const formatNumber = (num: number) => {
        if (typeof num !== 'number') return num;
        if ((locale === 'de' || locale === 'fr') && num >= 1000) {
            return num?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '\u202F');
        }
        if (locale === 'it') {
            return num?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        }
        return num?.toString();
    };

    const items: any[] = [
        {
            video: (() => {
                const map: any = {
                    en: 'https://websiteoss.ecoflow.com/upload/video/1760322639260/%E5%8D%95-en.mp4',
                    de: 'https://websiteoss.ecoflow.com/upload/video/1760322622371/%E5%8D%95-de.mp4',
                };
                return map[locale] || map.en;
            })(),
            poster: (() => {
                const map: any = {
                    en: 'https://websiteoss.ecoflow.com/upload/image/1754398329224/8-1_en.jpg',
                    de: 'https://websiteoss.ecoflow.com/upload/image/1754398316223/8-1_de.jpg',
                };
                return map[locale] || map.en;
            })(),
            title: t('H_item1_title'),
            desc: t('H_item1_desc'),
            power: [1200, 1100],
        },
        {
            video: (() => {
                const map: any = {
                    en: 'https://websiteoss.ecoflow.com/upload/video/1760079764574/%E7%AB%9E%E5%93%81-en.mp4',
                    de: 'https://websiteoss.ecoflow.com/upload/video/1760079764574/%E7%AB%9E%E5%93%81-en.mp4',
                };
                return map[locale] || map.en;
            })(),
            poster: (() => {
                const map: any = {
                    en: 'https://websiteoss.ecoflow.com/upload/image/1754398335098/8-2_en.jpg',
                    de: 'https://websiteoss.ecoflow.com/upload/image/1754398320569/8-2_de.jpg',
                };
                return map[locale] || map.en;
            })(),
            title: t('H_item2_title'),
            desc: t('H_item2_desc'),
            power: [800, 1500],
        },
        {
            video: (() => {
                const map: any = {
                    en: 'https://websiteoss.ecoflow.com/upload/video/1760079764256/%E5%8F%8C-en.mp4',
                    de: 'https://websiteoss.ecoflow.com/upload/video/1760079764844/%E5%8F%8C-de.mp4',
                };
                return map[locale] || map.en;
            })(),
            poster: (() => {
                const map: any = {
                    en: 'https://websiteoss.ecoflow.com/upload/image/1754398372669/8-3_en.jpg',
                    de: 'https://websiteoss.ecoflow.com/upload/image/1754398324553/8-3_de.jpg',
                };
                return map[locale] || map.en;
            })(),
            title: t('H_item3_title'),
            desc: t('H_item3_desc'),
            power: [2300, 0],
        },
        {
            video: (() => {
                const map: any = {
                    en: 'https://websiteoss.ecoflow.com/upload/video/1760079764574/%E7%AB%9E%E5%93%81-en.mp4',
                    de: 'https://websiteoss.ecoflow.com/upload/video/1760079764574/%E7%AB%9E%E5%93%81-en.mp4',
                };
                return map[locale] || map.en;
            })(),
            poster: (() => {
                const map: any = {
                    en: 'https://websiteoss.ecoflow.com/upload/image/1754398335098/8-2_en.jpg',
                    de: 'https://websiteoss.ecoflow.com/upload/image/1754398320569/8-2_de.jpg',
                };
                return map[locale] || map.en;
            })(),
            title: t('H_item4_title'),
            desc: t('H_item4_desc'),
            power: [800, 1500],
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const sceneH = AniContainer.create({
                triggerElement: '.stream-ultra-x-D',
                triggerHook: 1,
                onEnter: () => setLoad(true),
            });
            return () => {
                sceneH.destroy();
            };
        }
    }, []);

    return (
        <section
            className={`${css.section} stream-ultra-x-H GtmModuleData-section`}
            id="stream-ultra-x-H"
            data-section-id={'stream-ultra-x-H'}
            data-section-title={t('H_title')}
        >
            <p className="title">{t('H_title')}</p>
            <ul className="items">
                {items?.map((item: any, k: number) => (
                    <>
                        {k === 2 && (
                            <p className="desc" key={`${k}-desc`}>
                                {t('H_desc')}
                            </p>
                        )}
                        <li className={`item item-${k + 1}`} key={k}>
                            {/* EcoVideo 在安卓手机Edge/FireFox上不播放 */}
                            <div className="item-video">
                                {load && (
                                    <video
                                        poster={item.poster}
                                        src={item.video}
                                        autoPlay
                                        loop
                                        muted
                                        width="100%"
                                        height="100%"
                                        preload="metadata"
                                        playsInline
                                        aria-label={t('H_title')}
                                    />
                                )}
                            </div>
                            <div className="item-info">
                                <p className="item-title">{item.title}</p>
                                <p className="item-desc">{item.desc}</p>
                                <div className="item-bar">
                                    <ul className="item-power">
                                        {item?.power?.map((po: number, m: number) => (
                                            <li
                                                className={`item-po item-po-${m + 1}`}
                                                key={`${k}-${m}`}
                                                style={{ width: `${(po / (item.power[0] + item.power[1])) * 100}%`, display: po ? 'block' : 'none' }}
                                            >
                                                {po ? (locale === 'eu' ? `${formatNumber(po)}W` : `${formatNumber(po)} W`) : ''}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </li>
                    </>
                ))}
            </ul>
        </section>
    );
};

export default H;
